/**
 * Builds the property dashboard overview URL from the properties base path and a listing alias.
 * This is the canonical landing route for a property; the bare `/properties/<alias>` path has no
 * route and 404s, so the `/dashboard/overview` suffix is owned here to keep every link consistent.
 */
export default function getPropertyDashboardOverviewUrl(propertiesBasePath: string, listingAlias: string) {
  return `${propertiesBasePath}/${listingAlias}/dashboard/overview`;
}
